import axios from 'axios'
import baseService from './baseService'
import carfaxModelMappingData from './data/carfaxModelMapping'

const appService = {
  /*
   * The learned CARFAX model mappings for ONE description - what this dealership has filed when CARFAX
   * said this model and series. Fetched by MakeModelSelector when its CARFAX comparison opens.
   *
   * ⚠ No longer the whole table at login (code review on #1589). That list was unpaged and only grew,
   * and nothing reloaded it after a save, so a correction made this morning was not suggested until the
   * next login. One description is a handful of rows on an index seek.
   *
   * ⚠ Plain axios, deliberately NOT one of baseService's cached instances: a cached answer would offer
   * the pre-correction suggestion straight after a correction is saved.
   */
  carfaxModelMappingsFor (carfaxModel, carfaxSeries) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(carfaxModelMappingData.all)
      } else {
        axios
          .get('/appraisal/getcarfaxmodelmappingsfor', Object.assign({}, baseService.defaultConfig, {
            params: { carfaxModel: carfaxModel, carfaxSeries: carfaxSeries }
          }))
          .then(response => {
            let apiResults = {...response.data}
            resolve(apiResults)
          })
          .catch(error => {
            reject(error.response ? error.response.data : error)
          })
      }
    })
  }
}

export default appService
